@if (chartWrapper) {
    <vc-chart-wrapper [contentHeight]="contentHeight" [loading]="loading" [title]="title">
        <ng-container chartActionsRightSide *ngTemplateOutlet="chartWrapperEndTemplate"></ng-container>
        <highcharts-chart
            class="no-title vc-pie-chart"
            [style.height]="height"
            [options]="options"
            (chartInstance)="onChartInstance($event)">
        </highcharts-chart>
    </vc-chart-wrapper>
} @else {
    <div [style.height]="contentHeight" [vcProgressSpinner]="loading">
        <ng-content></ng-content>
        <highcharts-chart
            class="no-title vc-pie-chart"
            [vcProgressSpinner]="loading"
            [style.height]="height"
            [options]="options"
            (chartInstance)="onChartInstance($event)">
        </highcharts-chart>
    </div>
}
